export default "__VITE_ASSET__BuxU21Zx__"